type PendingOpcoRef = { current: string | undefined }

export const updateOpcoQueryParam = (href: string, opco: string): string => {
  const url = new URL(href)
  url.searchParams.set('opco', opco)
  return `${url.pathname}${url.search}${url.hash}`
}

export const getOpcoFromSwitcherOptionId = (id: string): string | undefined => {
  const match = id.match(/^(?:banner-opco-selector|preferences-opco-selector)-items--(.+)$/)
  return match?.[1]
}

export const handleOpcoSwitcherClickCapture = (
  target: EventTarget | null,
  pendingOpco: PendingOpcoRef,
  updateUrl: (opco: string) => void
) => {
  if (!(target instanceof HTMLElement)) {
    return
  }

  const option = target.closest<HTMLButtonElement>(
    'button[id^="banner-opco-selector-items--"], button[id^="preferences-opco-selector-items--"]'
  )
  const nextOpco = option ? getOpcoFromSwitcherOptionId(option.id) : undefined
  if (nextOpco && option) {
    const isPreferencesOption = option.id.startsWith('preferences-opco-selector-items--')
    if (isPreferencesOption) {
      pendingOpco.current = nextOpco
    } else {
      updateUrl(nextOpco)
    }
    return
  }

  if (target.closest('#opco-switcher-dialog button') && pendingOpco.current) {
    const dialog = target.closest('#opco-switcher-dialog')
    const buttons = dialog?.querySelectorAll('button')
    if (buttons?.[buttons.length - 1] === target.closest('button')) {
      updateUrl(pendingOpco.current)
      pendingOpco.current = undefined
    }
  }
}

export const handleOpcoSwitcherSubmitCapture = (
  target: EventTarget | null,
  pendingOpco: PendingOpcoRef,
  updateUrl: (opco: string) => void
) => {
  if (
    target instanceof HTMLFormElement &&
    target.closest('[data-testid="preferences-selector"]') &&
    pendingOpco.current
  ) {
    updateUrl(pendingOpco.current)
    pendingOpco.current = undefined
  }
}
